'use strict';

import completeTemplate from './completeTicket.html';

var completeTicketController = function(workflowService) {

    var vm = this;

    vm.$onInit = function() {
        workflowService.completeTicket(vm.$stateParams.ticketId, vm.$stateParams.status);
    }

};

completeTicketController.$inject = ['workflowService'];

export var completeTicketComponent = {
    name: 'completeTicket',
    template: completeTemplate,
    controller: completeTicketController,
    bindings: {
        $stateParams: '<'
    }
};

export var completeTicketRoute = {
    name: 'completeTicket',
    url: '/complete/:ticketId/:status',
    component: 'completeTicket',
    params: {
        ticketId: null,
        status: null
    }
};